var _defs, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSber(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 103,
    height: 48,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442",
    x1: 11.99,
    y1: 3.06,
    x2: 88.95,
    y2: 49.02,
    gradientTransform: "matrix(1 0 0 -1 0 50)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00d900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#0bda00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#2adb00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#5bde00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#9fe200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#f5e700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f6e700"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_2",
    x1: 77.41,
    y1: 36.39,
    x2: 104.48,
    y2: 13.24,
    gradientTransform: "matrix(1 0 0 -1 0 50)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#eef3ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_3",
    cx: -866.04,
    cy: 540.38,
    r: 1,
    gradientTransform: "matrix(21.64 0 0 -20.92 18824.61 11322.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0 8h103v32H0z"
  })), /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none}.cls-7{fill:#21a038}.cls-8{fill:#fff}"))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clip-path)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.19 34.78h78.56A11 11 0 0 0 100.94 24a11 11 0 0 0-11.19-10.86H11.19A11 11 0 0 0 0 24a11 11 0 0 0 11.19 10.78Z",
    style: {
      fill: "url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442)"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M75.63 10.42h28.51v27.56H75.63z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M89.55 12.87A11.32 11.32 0 0 1 101.06 24a11.51 11.51 0 0 1-23 0 11.32 11.32 0 0 1 11.49-11.13Z",
    style: {
      fill: "url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_2)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.55 35.13A11.33 11.33 0 0 1 78.05 24a11.51 11.51 0 0 1 23 0 11.33 11.33 0 0 1-11.5 11.13Zm0-22A11.08 11.08 0 0 0 78.3 24a11.26 11.26 0 0 0 22.51 0 11.09 11.09 0 0 0-11.26-10.87Z",
    style: {
      fill: "url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_3)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M72.99 8h33.1v32h-33.1z",
    style: {
      opacity: 0.33
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m85.21 20.25-1 .61v-.81l1.23-.77H86v4.66h-.8ZM88.76 24a2.48 2.48 0 0 1-.75-.1 1.64 1.64 0 0 1-.58-.27 1.36 1.36 0 0 1-.36-.43 1.37 1.37 0 0 1-.13-.58 1.41 1.41 0 0 1 0-.35.94.94 0 0 1 .39-.6 1.16 1.16 0 0 1 .42-.19 1.28 1.28 0 0 1-.27-.11 1.15 1.15 0 0 1-.23-.21.89.89 0 0 1-.15-.29 1.12 1.12 0 0 1-.06-.38 1.08 1.08 0 0 1 .42-.9 2 2 0 0 1 1.24-.33 1.9 1.9 0 0 1 1.21.32 1 1 0 0 1 .4.86 1.12 1.12 0 0 1-.18.64.87.87 0 0 1-.52.39 1.07 1.07 0 0 1 .67.39 1.15 1.15 0 0 1 .23.74 1.31 1.31 0 0 1-.12.56 1.34 1.34 0 0 1-.34.45 1.74 1.74 0 0 1-.56.29 2.68 2.68 0 0 1-.73.1Zm0-.78a1.28 1.28 0 0 0 .74-.17.63.63 0 0 0 .24-.54.56.56 0 0 0-.26-.52 1.42 1.42 0 0 0-.72-.16c-.66 0-1 .23-1 .67a.67.67 0 0 0 .08.33.5.5 0 0 0 .2.23.88.88 0 0 0 .31.13 2.5 2.5 0 0 0 .41.03Zm0-2a1 1 0 0 0 .63-.16.55.55 0 0 0 .19-.45.52.52 0 0 0-.18-.43 1.51 1.51 0 0 0-1.29 0 .5.5 0 0 0-.2.44.51.51 0 0 0 .2.41 1 1 0 0 0 .63.18ZM91.14 21.64a3.46 3.46 0 0 1 .15-1.09 1.81 1.81 0 0 1 .39-.73 1.37 1.37 0 0 1 .58-.41 1.82 1.82 0 0 1 .7-.14 1.92 1.92 0 0 1 .77.15 1.55 1.55 0 0 1 .58.44 2.05 2.05 0 0 1 .37.74 3.56 3.56 0 0 1 .13 1 3.52 3.52 0 0 1-.15 1.1 2 2 0 0 1-.39.73 1.54 1.54 0 0 1-.58.41A2.08 2.08 0 0 1 93 24a1.87 1.87 0 0 1-.76-.15 1.47 1.47 0 0 1-.58-.44 2.05 2.05 0 0 1-.37-.74 3.93 3.93 0 0 1-.15-1.03Zm.82 0a3.15 3.15 0 0 0 .07.74 1.61 1.61 0 0 0 .2.49.91.91 0 0 0 .32.27 1 1 0 0 0 .43.09 1 1 0 0 0 .43-.09.69.69 0 0 0 .32-.27 1.17 1.17 0 0 0 .19-.49 3.15 3.15 0 0 0 .07-.74 3.71 3.71 0 0 0-.07-.74 1.48 1.48 0 0 0-.21-.49.83.83 0 0 0-.32-.27 1.13 1.13 0 0 0-.86 0 .91.91 0 0 0-.32.27 1.47 1.47 0 0 0-.19.49 4.06 4.06 0 0 0-.02.74ZM86.52 26.12h-1.11v.42a6.74 6.74 0 0 1-.14 1.22 2.07 2.07 0 0 1-.26.67.67.67 0 0 1-.35.29 1.32 1.32 0 0 1-.39.06H83.93V28a.57.57 0 0 0 .18 0 .54.54 0 0 0 .21-.05c.06 0 .12-.1.17-.22a2.35 2.35 0 0 0 .13-.54 9.89 9.89 0 0 0 .07-1v-.72h2.6v3.29h-.79ZM91.09 28.41a.61.61 0 0 1-.17.14 1.46 1.46 0 0 1-.28.13 1.82 1.82 0 0 1-.37.09 1.91 1.91 0 0 1-.43 0 1.86 1.86 0 0 1-1.32-.43 1.72 1.72 0 0 1-.47-1.3 2.11 2.11 0 0 1 .12-.73 1.55 1.55 0 0 1 .36-.53 1.47 1.47 0 0 1 .55-.33 2 2 0 0 1 .71-.11 1.57 1.57 0 0 1 1.21.46 1.64 1.64 0 0 1 .42 1.2v.32h-2.58c.06.55.41.82 1 .82a1.81 1.81 0 0 0 .78-.15 1.21 1.21 0 0 0 .45-.37v.79Zm-1.32-2.36a1 1 0 0 0-.62.18.83.83 0 0 0-.3.54h1.72a.74.74 0 0 0-.22-.53.88.88 0 0 0-.58-.19ZM92.88 26.12h-1.09v-.67h3v.67h-1.1v2.62h-.79v-2.62Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m36.64 22.27 1.3-.92H33.6v5.55h4.34V26h-3.1v-1.45h2.64v-.92h-2.64v-1.36ZM30.33 23.51h-1.51v-1.24h2.4l1.3-.92h-4.94v5.55h2.58c1.46 0 2.29-.64 2.29-1.75s-.76-1.64-2.12-1.64ZM30.11 26h-1.29v-1.57h1.29c.78 0 1.15.26 1.15.77s-.39.8-1.15.8ZM41.46 21.35h-2.37v5.55h1.24v-1.57h1.12c1.51 0 2.45-.77 2.45-2s-.9-1.98-2.44-1.98Zm0 3h-1.1v-2.08h1.1c.79 0 1.23.38 1.23 1.07s-.47 1.06-1.26 1.06ZM25.45 25.7a2.22 2.22 0 0 1-1.06.26 1.84 1.84 0 1 1 0-3.67 1.88 1.88 0 0 1 1.12.34l.89-.63h-.06a3 3 0 0 0-2-.68 3.24 3.24 0 0 0-2.2.79 2.73 2.73 0 0 0-.87 2 2.8 2.8 0 0 0 .87 2.06 3.16 3.16 0 0 0 2.19.82 3 3 0 0 0 2.2-.85l-.8-.57ZM18.4 24.12a4.39 4.39 0 0 0-.07-.82l-1 .73v.09a3.67 3.67 0 1 1-3.67-3.54 3.74 3.74 0 0 1 2.07.62l.93-.67a4.85 4.85 0 0 0-3-1 4.61 4.61 0 1 0 0 9.22 4.69 4.69 0 0 0 4.74-4.63Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M17.41 21.3a5.06 5.06 0 0 1 .57.92l-4.35 3.1-1.81-1.1v-1.33L13.63 24ZM49.23 23.51h-1.51v-1.24H51v-.92h-4.51v5.55h2.58c1.45 0 2.28-.64 2.28-1.75s-.75-1.64-2.12-1.64ZM49 26h-1.3v-1.57H49c.78 0 1.15.26 1.15.77s-.37.8-1.15.8ZM66.66 26.9H65.4v-5.55h1.26v2.33h.68l1.85-2.33h1.42L68.42 24 71 26.9h-1.7l-1.87-2.19h-.77ZM56.21 25.82h-2.65l-.45 1.08h-1.34l2.49-5.55h1.34l2.45 5.55h-1.38Zm-.41-1-.91-2.16-.89 2.15ZM60.23 21.35v2.31h2.6v-2.31h1.3v5.55h-1.3v-2.19h-2.6v2.19h-1.29v-5.55Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSber);
export default __webpack_public_path__ + "static/media/sber.a6838179f78fffd6693d29882fa66d31.svg";
export { ForwardRef as ReactComponent };